const Loading = () =>{
    return (
        <div className="stretch-to-screen flex flex-col justify-center items-center gap-y-5 bg-black">
            <div class="charging-container"></div>
            <h1 className="text-white text-3xl font-bold tracking-widest animate-pulse"><span className="text-[#2695ff]">LOAD</span>ING</h1>
        </div>
    )
}

export default Loading